import { render, staticRenderFns } from "./colourConfig.vue?vue&type=template&id=690b0590&scoped=true"
import script from "./colourConfig.vue?vue&type=script&lang=js"
export * from "./colourConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690b0590",
  null
  
)

export default component.exports